import React from "react";

// Call Logs nav icon — a phone receiver with a small clock badge in
// the upper-right corner. The phone says "calls", the clock says
// "history/log". Together they unambiguously mean "call history",
// matching the visual pattern used by iOS Recents and Material's
// Phone + History combo.
const CallLogs = ({ fill }: { fill: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Phone handset (classic curved receiver) */}
    <path
      d="M3.5 6.5c0-1.66 1.34-3 3-3h.93c.6 0 1.14.36 1.37.91l1.06 2.55a1.5 1.5 0 0 1-.32 1.65l-.85.85a11 11 0 0 0 4.8 4.8l.85-.85a1.5 1.5 0 0 1 1.65-.32l2.55 1.06a1.5 1.5 0 0 1 .91 1.37v.93a3 3 0 0 1-3 3A15.5 15.5 0 0 1 3.5 6.5Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    {/* Clock badge — "log/recent" indicator, punched through with
        a white fill so it reads as a separate overlay regardless
        of where the phone outline ends up. */}
    <circle
      cx="18"
      cy="6"
      r="3.5"
      fill="white"
      stroke={fill}
      strokeWidth="1.5"
    />
    <path
      d="M18 4.5V6L19.3 6.7"
      stroke={fill}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CallLogs;
